module.exports = __webpack_public_path__ + "static/media/create-delivery-icon.9b78f5fa.svg";